export default function Checkbox({
  value,
  onChange,
  id,
}: {
  value: boolean;
  onChange: (checked: boolean) => void;
  id?: string;
}) {
  return (
    <div
      className="flex items-center space-x-3 cursor-pointer"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onChange(!value);
      }}
    >
      <label className="inline-flex items-center space-x-3 cursor-pointer select-none">
        <input
          type="checkbox"
          className="hidden peer"
          checked={value}
          readOnly
        />
        <div
          id={id}
          className={`w-5 h-5 rounded border flex items-center justify-center transition ${
            value
              ? "border-purple-600 bg-purple-600"
              : "border-gray-300 bg-white"
          }`}
        >
          {value && (
            <svg
              width="12"
              height="9"
              viewBox="0 0 12 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.56166 8.40774L11.5079 1.46149L10.3502 0.303741L4.56166 6.09224L1.66166 3.19224L0.503906 4.34999L4.56166 8.40774Z"
                fill="white"
              />
            </svg>
          )}
        </div>
      </label>
    </div>
  );
}
